<template>
  <div class="editPropertiesProperty"
    @mouseenter="showControls = true"
    @mouseleave="showControls = false"
  >
    <span v-show="!showUpdateProperty">{{ property.name }}</span>
    <div class="editPropertiesProperty-controls"
      v-show="showControls && !showUpdateProperty"
    >
      <neb-icon name="edit" height="12px" width="12px"
        @click.native="onEditClick"
      />
      <neb-icon name="trash" height="12px" width="12px"
        @click.native="showDeleteModal = true; showControls = false"
      />
    </div>
    <div class="editPropertiesProperty-updateProperty"
      v-if="showUpdateProperty"
      v-loading="updatePropertyLoading"
    >
      <neb-input placeholder="Enter Property Name"
        v-model="updatePropertyValue"
        @keyup.enter.native="onUpdatePropertySubmit"
      />
      <neb-icon name="check" height="16px" width="16px"
        @click.native="onUpdatePropertySubmit"
      />
      <neb-icon name="x" height="16px" width="16px"
        @click.native="showUpdateProperty = false"
      />
    </div>
    <neb-modal title="Delete Property"
      :isOpen="showDeleteModal"
      @clickOutside="showDeleteModal = false"
    >
      <p>You are about to permanently delete a custom property. This will delete all custom values under this property across all content.</p>
      <p>Are you sure you want to delete this property?</p>
      <template v-slot:footer>
        <div class="editPropertiesProperty-deleteControls">
          <neb-form-control>
            <neb-button type="secondary"
              @click="showDeleteModal = false"
            >Cancel</neb-button>
            <neb-button type="primary"
              @click="onDeleteClick"
            >Delete</neb-button>
          </neb-form-control>
        </div>
      </template>
    </neb-modal>
  </div>
</template>

<script>
import NebIcon from '@/components/Nebula/Icon'
import { ref } from '@vue/composition-api'
import NebModal from '@/components/Nebula/layout/Modal'
import NebButton from '@/components/Nebula/controls/Button'
import NebFormControl from '@/components/Nebula/controls/FormControl'
import NebInput from '@/components/Nebula/controls/Input'

export default {
  name: 'EditPropertiesProperty',

  components: {
    NebIcon,
    NebModal,
    NebButton,
    NebFormControl,
    NebInput
  },

  props: {
    property: {
      type: Object,
      required: true
    },
    updatePropertyLoading: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'action:deleteProperty',
    'action:updateProperty'
  ],

  setup (props, { emit }) {
    const showControls = ref(false)
    const showDeleteModal = ref(false)
    const showUpdateProperty = ref(false)
    const updatePropertyValue = ref('')

    const onDeleteClick = () => {
      emit('action:deleteProperty', props.property)
      showDeleteModal.value = false
    }
    const onUpdatePropertySubmit = () => {
      emit('action:updateProperty', { property: props.property, value: updatePropertyValue.value })
      showUpdateProperty.value = false
    }
    const onEditClick = () => {
      updatePropertyValue.value = props.property.name
      showUpdateProperty.value = true
      showControls.value = false
    }

    return {
      showControls,
      showDeleteModal,
      onDeleteClick,
      showUpdateProperty,
      onUpdatePropertySubmit,
      updatePropertyValue,
      onEditClick
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.editPropertiesProperty {
  padding-bottom: 5px;
  display: flex;
  column-gap: 5px;

  &-updateProperty {
    display: flex;
    align-items: center;
    column-gap: 5px;
    padding-bottom: 5px;

    .nebIcon.x {
      cursor: pointer;
      color: $slate-grey;
    }

    .nebIcon.check {
      color: green;
      cursor: pointer;
    }
  }

  span {
    display: block;
    font-family: $defaultFont;
    font-size: 12px;
    font-weight: 500;
    color: $slate-grey;
  }

  &-controls {
    display: flex;
    align-items: center;
    column-gap: 5px;
    transition: all 0.3s;

    .nebIcon {
      cursor: pointer;
    }

    .nebIcon.edit {
      color: $tiffany-blue;
    }

    .nebIcon.trash {
      color: red;
    }
  }

  &-deleteControls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
